import { html } from 'lit';
import { getI18n } from './_i18n/i18n.js';

export function Loading() {
  const literals = getI18n(document.documentElement.lang);
  return html`
    <div class="flex justify-center p-4">
      <div class="inline-block">${literals.loading}</div>
    </div>
  `;
}
